import { Platform } from "react-native";
import axios from "axios";

const getBaseUrl = () => {
  if (Platform.OS === "web") {
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;
      if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "http://localhost:8082";
      }

      return "https://getmeeza.com/prollix";
    }
  }
  //return "http://172.20.10.5:8082";
  return "https://getmeeza.com/prollix";
};

export const BASE_URL = getBaseUrl();

const getFrontendUrl = () => {
  if (Platform.OS === "web" && typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:8082"; // or whatever port your Expo web dev server uses
    }
  }
  return "https://app.getmeeza.com";
};

export const FRONTEND_URL = getFrontendUrl();

// 1. Core Public Network Config
export default axios.create({
  baseURL: BASE_URL,
});

// 2. Core Private Network Config (Handles Auth, Access Tokens & Automated Secure Cookies)
export const axiosWithCredentials = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // 🌟 ESSENTIAL: Forces browser to append the secure cookie automatically
});
